export default __webpack_public_path__ + "slices/main/assets/public/fonts/tiempos/tiempos-headline-semibold.28e301799f3ab3362590b9f6b07e487a.woff";